import { toast } from "react-toastify";
import { _QualityInspectionItem, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean"
import { BasicTable } from "../../../../theme/Component/BasicTable"
import { useEffect, useState } from "react";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from "../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { SelectProductEditor } from "../../../ManufacturingStandars/Components/SelectProductEditor";
import { AccountEditor } from "../../../../editor/AccountEditor";
import usePaginator from "../../../../theme/Component/usePaginator";
import { ListJSONQualityInspectionItems } from "./ListJSONQualityInspectionItems";
import { ListJSONDefectQualityInspectionItems } from "./ListJSONDefectQualityInspectionItems";
import { ListJSONPuntajeQualityInspectionItems } from "./ListJSONPuntajeQualityInspectionItems";
import { DropDown } from "../../../../theme/Component/DropDown";
import { ExportXLSL } from "../../../../theme/Component/ExportXLSX";
import { InputDate } from "../../../../theme/Input/InputDate";
import { BasicButton } from "../../../../theme/Component/BasicButton";

interface componentData {
    QualityInspection: any;
    isReport?: boolean;
}

interface formData {
    FromDate: any;
    UptoDate: any;
    IDAccount: number;
    IDProduct: number;
}

export const QualityInspectionItems = ({ QualityInspection, isReport }: componentData) => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_QualityInspectionItem)
    const paginator = usePaginator();

    const [form, setForm] = useState<Partial<formData>>({})

    const modal = useModal("", MODAL_LG);
    const modalC = useModal("Eliminar Inspección", MODAL_SM);

    const head = [
        { title: 'ID', property: 'IDQualityInspectionItem', visible: true },
        { title: 'Fecha de Revisión', property: 'ReviewDate', visible: true },
        { title: 'Producto', property: 'ProductName', visible: true },
        { title: 'Numero de Rollo', property: 'NoRollo', visible: true },
        { title: 'Tono', property: 'TonoProducto', visible: true },
        { title: 'Cantidad de Metros', property: 'CantMetros', visible: true },
        { title: 'Cantidad de Metros a Revisar', property: 'CantMetrosRevision', visible: true },
        { title: 'Medición de Ancho', property: 'RenderSizes', visible: true, Style: { width: "200px" } },
        { title: 'Código de Defecto', property: 'RenderDefects', visible: true, Style: { width: "200px" } },
        { title: 'Puntaje de Demeritos', property: 'RenderDemeritos', visible: true, Style: { width: "150px" } },
        { title: 'Total de Puntos', property: 'TotalPuntos', visible: true },
        { title: 'Empleado que Revisa', property: 'EmployeeReviewFullName', visible: true },
        { title: 'Empleado que Revisa Tonalidad', property: 'EmployeeTonalidadFullName', visible: true },
        { title: 'Observaciones', property: 'Observaciones', visible: true },
    ];

    const renderDefect = (defectos: any[]) => {
        if (!defectos || defectos.length === 0) return "N/P";

        const render = defectos.map((medida, index) => {
            return `
                <strong key={${index}} >${medida.Name}</strong>
        `;
        });
        return render.join(", ");
    };

    const renderSizes = (medidas: any[]) => {
        if (!medidas || medidas.length === 0) return "N/P";

        const render = medidas.map((medida, index) => {
            return `
            <div key="${index}">
                <strong>${medida.Name} - </strong>
                <strong>${medida.value} m</strong>
            </div>
        `;
        });
        return render.join("");
    };

    const renderDemeritos = (demeritos: any[]) => {
        if (!demeritos || demeritos.length === 0) return "N/P";

        const render = demeritos.map((medida, index) => {
            return `
            <div key="${index}">
                <strong>${medida.Name} - </strong>
                <strong>Cantidad: ${medida.value}</strong>
            </div>
        `;
        });
        return render.join("");
    };

    useEffect(() => {
        if (QualityInspection?.IDQualityInspection) {
            getLista();
        } else if (isReport) {
            getLista();
        }
    }, [QualityInspection?.IDQualityInspection, paginator.page])

    const getLista = () => {
        const props: any = {
            IDQualityInspection: QualityInspection?.IDQualityInspection,
            State: 1
        }

        if (form.IDAccount) props.IDEmployeeReview = form.IDAccount
        if (form.IDProduct) props.IDProduct = form.IDProduct

        instance.getQualityInspectionItemRender(paginator.page, 15, props, form.FromDate, form.UptoDate).then(
            (resp) => {
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * 15);
                resp.List.forEach(element => {
                    const values = element.DataBeanProperties;
                    let defects = [];
                    let sizes = [];
                    let demeritos = [];

                    if (values.JSONCodigoDefecto) {
                        try {
                            defects = JSON.parse(values.JSONCodigoDefecto);
                        } catch (err) {
                            console.error("Error parseando JSONCodigoDefecto:", err);
                        }
                    }
                    if (values.JSONMedicionAncho) {
                        try {
                            sizes = JSON.parse(values.JSONMedicionAncho);
                        } catch (err) {
                            console.error("Error parseando JSONMedicionAncho:", err);
                        }
                    }
                    if (values.JSONPuntajeDemeritos) {
                        try {
                            demeritos = JSON.parse(values.JSONPuntajeDemeritos);
                        } catch (err) {
                            console.error("Error parseando JSONPuntajeDemeritos:", err);
                        }
                    }

                    values.RenderDefects = renderDefect(defects);
                    values.RenderSizes = renderSizes(sizes);
                    values.RenderDemeritos = renderDemeritos(demeritos);
                });
                setLista(resp.List)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const deleteItem = () => {
        let x = { ...bean, State: 2 };
        editaItem(x);
    };

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
            IDQualityInspection: QualityInspection?.IDQualityInspection,
            IDEmployeeReview: _single.getAccountID(),
            ReviewDate: _single.getCurrenDate(),
        });
        modal.open("Agregar Inspección");
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate() && (!isReport), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit() && (!isReport), evento: () => { modal.open("Editar Inspección Realizada") } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete() && (!isReport), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const editaItem = (obj: any) => {
        instance.updateQualityInspectionItem(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const validateForm = () => {
        const requiredFields = [

        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    useEffect(() => {
        if (bean.IDQualityInspectionItem) return;
        if (bean.CantMetrosRevision && bean.JSONMedicionAncho && bean.JSONPuntajeDemeritos) {
            let codigoDefecto: { CodeID: number; value: number }[] = [];
            let medicionAncho: { value: number }[] = [];

            try {
                codigoDefecto = JSON.parse(bean.JSONPuntajeDemeritos);
            } catch (e) {
                console.error("Error al parsear JSONPuntajeDemeritos", e);
            }

            try {
                medicionAncho = JSON.parse(bean.JSONMedicionAncho);
            } catch (e) {
                console.error("Error al parsear JSONMedicionAncho", e);
            }

            const totalPoints = codigoDefecto.reduce((acc, item) => acc + (Number(item.CodeID) * Number(item.value)), 0);

            const values = medicionAncho.map(item => Number(item.value));
            const ponderadoTela = values.length > 0 ? values.reduce((a, b) => a + b, 0) / values.length : 0;

            const totalMetros = Number(bean.CantMetrosRevision) || 0;

            const formulaResult = totalMetros && ponderadoTela
                ? (totalPoints / (totalMetros * ponderadoTela)) * 100
                : 0;

            setBean({ ...bean, TotalPuntos: formulaResult });
        }
    }, [bean.CantMetrosRevision, bean.JSONMedicionAncho, bean.JSONPuntajeDemeritos]);

    const modalGraph = useModal("Reporte Excel", MODAL_SM);
    const [listaExport, setListaExport] = useState<any[]>([]);

    const getListaExport = () => {
        const props: any = {
            IDQualityInspection: QualityInspection?.IDQualityInspection,
            State: 1
        }

        if (form.IDAccount) props.IDEmployeeReview = form.IDAccount
        if (form.IDProduct) props.IDProduct = form.IDProduct

        instance.getQualityInspectionItemRender(1, paginator.pages * 15, props, form.FromDate, form.UptoDate).then(
            (resp) => {
                resp.List.forEach(element => {
                    const values = element.DataBeanProperties;
                    let defects = [];
                    let sizes = [];
                    let demeritos = [];


                    const toDefectsText = (arr: any[]) =>
                        (arr ?? []).map(d => d?.Name).filter(Boolean).join(", ") || "N/P";

                    const toSizesText = (arr: any[]) =>
                        (arr ?? []).map(s => `${s?.Name} - ${s?.value} m, `).join("\n") || "N/P";

                    const toDemeritosText = (arr: any[]) =>
                        (arr ?? []).map(d => `${d?.Name} - Cantidad: ${d?.value}; `).join("\n") || "N/P";

                    if (values.JSONCodigoDefecto) {
                        try {
                            defects = JSON.parse(values.JSONCodigoDefecto);
                        } catch (err) {
                            console.error("Error parseando JSONCodigoDefecto:", err);
                        }
                    }
                    if (values.JSONMedicionAncho) {
                        try {
                            sizes = JSON.parse(values.JSONMedicionAncho);
                        } catch (err) {
                            console.error("Error parseando JSONMedicionAncho:", err);
                        }
                    }
                    if (values.JSONPuntajeDemeritos) {
                        try {
                            demeritos = JSON.parse(values.JSONPuntajeDemeritos);
                        } catch (err) {
                            console.error("Error parseando JSONPuntajeDemeritos:", err);
                        }
                    }

                    values.RenderDefects = toDefectsText(defects);
                    values.RenderSizes = toSizesText(sizes);
                    values.RenderDemeritos = toDemeritosText(demeritos);
                });
                setListaExport(resp.List)
                modalGraph.open();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const actionsDropDown = [
        { id: 1, name: 'Reporte Excel', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            getListaExport();
                        }
                    }} />
                </div>
            </div>
        )
    }

    return (
        <div className="row">
            <div className="col-md-4">
                <InputDate name="" value={form.FromDate} label="Fecha desde" setDate={(e) => { setForm({ ...form, FromDate: e }) }} />
            </div>
            <div className="col-md-4">
                <InputDate name="" value={form.UptoDate} label="Fecha desde" setDate={(e) => { setForm({ ...form, UptoDate: e }) }} />
            </div>
            <div className="col-md-4">
                <AccountEditor idAccount={form.IDAccount} label="Empleado" onChange={(e) => { setForm({ ...form, IDAccount: e.IDAccount }) }} />
            </div>
            <div className="col-md-4">
                <SelectProductEditor label="Producto" value={form.IDProduct} onChange={(e) => { setForm({ ...form, IDProduct: e.IDProduct }) }} />
            </div>
            <div className="col-md-2">
                <BasicButton eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} useMargin />
            </div>
            <div className="col-md-12">
                <BasicTable
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    iconButtons={iconButtonsItem}
                    listButtons={listaBotones()}
                    pageTop={paginator.page}
                    next={paginator.next}
                    back={paginator.back}
                    records={paginator}
                    headButtons={buttons()}
                />
            </div>

            <div className="col-md-12">
                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }} >
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDProduct') ? 'has-error' : ''}`} >Producto/Insumo</label>
                            <SelectProductEditor filterType={1} label=" " onChange={(e) => { setBean({ ...bean, IDProduct: e.IDProduct }) }} renderValue="" />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('NoRollo') ? 'has-error' : ''}`} >Numero de Rollo</label>
                            <input type="text" value={bean.NoRollo} className="form-control" onChange={(e) => { setBean({ ...bean, NoRollo: e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('CantMetros') ? 'has-error' : ''}`} >Cantidad Metros</label>
                            <input type="number" value={bean.CantMetros} onChange={(e) => {
                                const value = e.target.value ? Number(e.target.value) : null
                                setBean({ ...bean, CantMetros: value })
                            }} className="form-control" />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('CantMetrosRevision') ? 'has-error' : ''}`} >Cantidad de Metros en Revisión</label>
                            <input type="number" value={bean.CantMetrosRevision} onChange={(e) => {
                                const value = e.target.value ? Number(e.target.value) : null
                                setBean({ ...bean, CantMetrosRevision: value })
                            }} className="form-control" />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('TonoProducto') ? 'has-error' : ''}`} >Tono del Producto</label>
                            <input type="text" value={bean.TonoProducto} onChange={(e) => { setBean({ ...bean, TonoProducto: e.target.value }) }} className="form-control" />
                        </div>
                        <div className="col-md-12">
                            <ListJSONQualityInspectionItems CodeSelector={900} labelSelector="Medición de Ancho" jsonProps={bean.JSONMedicionAncho} onChange={(e) => { setBean({ ...bean, JSONMedicionAncho: e }) }} />
                            {/* <SelectTHConstantsValue label=" " code={900} onChange={(e) => { setBean({ ...bean, MedicionAncho: e }) }} value={bean.MedicionAncho} /> */}
                        </div>
                        <div className="col-md-12">
                            <ListJSONPuntajeQualityInspectionItems CodeSelector={901} labelSelector="Puntaje Demeritos" jsonProps={bean.JSONPuntajeDemeritos} onChange={(e) => { setBean({ ...bean, JSONPuntajeDemeritos: e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDEmployeeReview') ? 'has-error' : ''}`} >Empleado que revisa</label>
                            <AccountEditor idAccount={bean.IDEmployeeReview} label=" " onChange={(e) => { setBean({ ...bean, IDEmployeeReview: e.IDAccount }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDEmployeeTonalidad') ? 'has-error' : ''}`} >Empleado que revisa la Tonalidad</label>
                            <AccountEditor idAccount={bean.IDEmployeeTonalidad} label=" " onChange={(e) => { setBean({ ...bean, IDEmployeeTonalidad: e.IDAccount }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('TotalPuntos') ? 'has-error' : ''}`} >Total Puntos</label>
                            <input type="number" value={bean.TotalPuntos} onChange={(e) => {
                                const value = e.target.value ? parseFloat(e.target.value) : null
                                setBean({ ...bean, TotalPuntos: value })
                            }} className="form-control" />
                        </div>
                        <div className="col-md-12">
                            <ListJSONDefectQualityInspectionItems CodeSelector={902} jsonProps={bean.JSONCodigoDefecto} labelSelector="Codigo de Defecto" onChange={(e) => { setBean({ ...bean, JSONCodigoDefecto: e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('Observaciones') ? 'has-error' : ''}`} >Observaciones</label>
                            <textarea className="form-control" value={bean.Observaciones} onChange={(e) => { setBean({ ...bean, Observaciones: e.target.value }) }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                    <div className="row">
                        <div className="col">
                            {lista.length > 0 &&
                                <ExportXLSL customName={"Insumos"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                    _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                }} />
                            }
                        </div>
                    </div>
                </Modal>

                <ModalConfirm eventModal={() => { deleteItem() }} updateModal={modalC.setModal} modal={modalC.modal} >
                    <strong>¿Desea Continuar con la accion?</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}